import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoadingScript: false
}
export const SalesForceSlice = createSlice({
    name: 'SalesForceSlice',
    initialState: initialState,
    reducers: {
      changeLoadingScript: (state, {payload}) => {
        state.isLoadingScript = payload
      }
    },
  });
  
export const {
  changeLoadingScript
} = SalesForceSlice.actions

export const betslipSelector = state => state.SalesForceSlice
export default SalesForceSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/SalesForceSlice.js